import '../../scss/components/scrollToTop'

const newcontent = document.createElement('div')
// newcontent.innerHTML = '<button id="scrollUp" class=""><div class="scroll"><i class="icon-up lh-1"></i><i class="icon-up"></i></div></button>'
newcontent.innerHTML = '<div id="scrollUp" class="link-primary"><svg class="progress-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102"><path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"></path></svg></div>'
document.body.appendChild(newcontent.firstElementChild)

const sBtn = document.getElementById('scrollUp')

// https://sandbox-react.netlify.app/demo-22
// https://stackoverflow.com/questions/2387136/cross-browser-method-to-determine-vertical-scroll-percentage-in-javascript
// https://codepen.io/JMChristensen/pen/AGbeEy
const getScrollPercent = () => {
  const h = document.documentElement
  const b = document.body
  const st = 'scrollTop'
  const sh = 'scrollHeight'
  return (h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight) * 100
}

const btnVisibility = () => {
  let pct = getScrollPercent()
  if (pct < 0) { pct = 0 }
  if (pct > 100) { pct = 100 }
  // const c = Math.PI * (sBtn.offsetWidth)
  // const offset = ((100 - pct) / 100) * c
  const offset = (100 - pct) * 307.919 / 100
  // setup le style initial via javascript sinon enfreint les règles CSP inline-src
  sBtn.querySelector('path').style.transition = 'stroke-dashoffset 10ms linear 0s'
  sBtn.querySelector('path').style.strokeDasharray = '307.919, 307.919'
  sBtn.querySelector('path').style.strokeDashoffset = offset

  if (window.scrollY > 200) {
    sBtn.classList.add('show')
  } else {
    sBtn.classList.remove('show')
  }
}

document.addEventListener('scroll', () => {
  btnVisibility()
})

sBtn.addEventListener('click', () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
})
